export default "__VITE_ASSET__e6WEuz09__"